<div class="container-fluid px-0 py-3">
  <div class="row">
    <div class="col-12 pb-2">
    <h3
      style=" font-weight: 700;font-size: 18px;margin-bottom: 1.5rem;display: flex; align-items: center;color: #313A44;">
        Business Information
      </h3>
    </div>
  </div>

  <form [formGroup]="business_details">
    <div class="row">
      <div class="col-xl-9 col-12">
        <div class="row">
        <!-- Filed Starts -->
          <div class="col-12 mb-3">
            <div
              [ngClass]="[business_details.controls.practice_name.touched && business_details.controls.practice_name.invalid ? 'custom-form  flex-grow-1 me-md-3   inputContainer' : 'custom-form flex-grow-1 me-md-3   ']">
              <input class="input_field px-3 pt-3" formControlName="practice_name" required trim  maxlength="100" />
            <label for="text" class="label-name">
              <span class="content-name f-c-p-3">
                Business Name
              </span>
              </label>
            </div>
            <p class="mat-error"
            *ngIf="business_details.controls.practice_name.touched && business_details.controls.practice_name.errors?.required ">
              Please enter business name.
            </p>
            <p class="mat-error"
              *ngIf="business_details.controls.practice_name.touched && business_details.controls.practice_name.errors?.minlength">
            Please enter valid business name.
          </p>
            <p class="mat-error"
            *ngIf="business_details.controls.practice_name.touched && business_details.controls.practice_name.invalid && business_details.controls.practice_name.errors && business_details.controls.practice_name.errors.pattern">
            Please enter valid business name.
          </p>
          </div>
          <!-- Field Ends -->

        <!-- Filed Starts -->
          <div class="col-12 mb-3">
            <div
            [ngClass]="[business_details.controls.practice_email.touched && business_details.controls.practice_email.invalid ? 'custom-form  flex-grow-1 me-md-3   inputContainer' : 'custom-form flex-grow-1 me-md-3   ']">
            <input class="input_field px-3 pt-3" formControlName="practice_email" required trim  />
            <label for="text" class="label-name">
              <span class="content-name f-c-p-3">
                Business Email Address
              </span>
              </label>
            </div>
            <p class="mat-error"
            *ngIf="business_details.controls.practice_email.touched && business_details.controls.practice_email.invalid && business_details.controls.practice_email.errors && !business_details.controls.practice_email.errors.pattern">
            Please enter email.
          </p>
            <p class="mat-error"
            *ngIf="business_details.controls.practice_email.touched && business_details.controls.practice_email.invalid && business_details.controls.practice_email.errors && business_details.controls.practice_email.errors.pattern">
            Please enter valid email.
          </p>
          </div>
        <!-- Field Ends -->
        <!-- Filed Starts -->
          <div class="col-12 mb-3">
            <div
              [ngClass]="[business_details.controls.practice_mobile && business_details.controls.practice_mobile.touched && business_details.controls.practice_mobile.invalid  ? 'inputContainer custom-form mt-3' : 'custom-form mt-3']">
              <span 
                *ngIf="business_details.controls.practice_mobile &&  (business_details.controls.practice_mobile.value !== null && business_details.controls.practice_mobile.value !== '')"
              class="pt-2 pe-1 fw-bold dollar_input" style="position: absolute;left: 14px;bottom: 8px;">
              +1
            </span>
              <input class="input_field pt-3"
                [ngStyle]="{'padding-left': business_details.value.practice_mobile !== '' ? '40px' : '1rem'}"
                name="practice_mobile" [formControl]="business_details.controls['practice_mobile']" [mask]="mask"
                required />
            <label for="text" class="label-name">
              <span class="content-name f-c-p-3">
                Business Phone Number
              </span>
              </label>
            </div>
            <p class="mat-error"
              *ngIf="business_details.controls.practice_mobile.invalid && business_details.controls.practice_mobile.errors?.required">
            Please enter your Phone Number
          </p>
            <p class="mat-error"
            *ngIf="business_details.controls.practice_mobile.touched && business_details.controls.practice_mobile.errors && business_details.controls.practice_mobile.errors?.pattern">
            Please enter valid Phone Number
          </p>
            <p class="mat-error"
              *ngIf="business_details.controls.practice_mobile.touched && !business_details.controls.practice_mobile.errors?.pattern && business_details.controls.practice_mobile.value == '0000000000'">
              Please enter valid Phone Number
            </p>
          </div>
        </div>
        <!-- Field Ends -->
        <div class="row">
          <!-- Address Starts -->
          <div class="col-md-7 mb-3">
            <div
                [ngClass]="[business_details.controls.practice_address.touched && business_details.controls.practice_address.invalid ? 'custom-form  flex-grow-1 me-md-3   inputContainer' : 'custom-form flex-grow-1 me-md-3   ']">
                <input class="input_field px-3 pt-3" formControlName="practice_address" required trim  />
                <label for="text" class="label-name">
                  <span class="content-name f-c-p-3">
                    Business Address
                  </span>
              </label>
            </div>
            <p class="mat-error"
              *ngIf="business_details.controls.practice_address.touched && business_details.controls.practice_address.invalid">
              Please enter your address.</p>
          </div>
          <!-- Address Ends -->

            <!-- Zip Starts -->

          <div class="col-md-5 mb-3">
            <div class="custom-form flex-grow-1 me-md-3" *ngIf="business_details.controls.zipCode.disabled">
              <input class="input_field px-3 pt-3" formControlName="zipCode" name="zipCode" />
                <label for="text" class="label-name">
                <span class="content-name f-c-p-3">
                  Zipcode
                </span>
              </label>
            </div>
            <zip-selector (zipSelected)="cahangeFormzip($event)" t="2" [isRequired]="true" id="zipPostalCode" 
              name="zipPostalCode" [model]="zip" ngDefaultControl *ngIf="!business_details.controls.zipCode.disabled">
            </zip-selector>
            <p *ngIf="business_details.controls.zipCode.invalid && business_details.controls.zipCode.touched "
            class="mat-error">
            Please enter a valid zip.
          </p>
          </div>
        </div>

        <div class="row">
          <!-- Filed Starts -->
          <div class="col-md-6 mb-3">
            <div
            [ngClass]="[business_details.controls.state.touched && business_details.controls.state.invalid ? 'custom-form  flex-grow-1 me-md-3   inputContainer' : 'custom-form flex-grow-1 me-md-3   ']">
            <input class="input_field px-3 pt-3" formControlName="state" required trim  />
            <label for="text" class="label-name">
              <span class="content-name f-c-p-3">
                State
              </span>
            </label>
            </div>
            <p class="mat-error"
            *ngIf="business_details.controls.state.touched && business_details.controls.state.invalid">
            Please select State.
          </p>
          </div>
        <!-- Field Ends -->

        <!-- Filed Starts -->
          <div class="col-md-6 mb-3">
            <div
            [ngClass]="[business_details.controls.city.touched && business_details.controls.city.invalid ? 'custom-form  flex-grow-1 me-md-3   inputContainer' : 'custom-form flex-grow-1 me-md-3   ']">
            <input class="input_field px-3 pt-3" formControlName="city" required trim  autocomplete="disbaled"/>
            <label for="text" class="label-name">
                <span class="content-name f-c-p-3">
                  City
                </span>
              </label>
            </div>
            <p class="mat-error" *ngIf="business_details.controls.city.touched && business_details.controls.city.invalid">
              Please enter your city.
            </p>
          </div>
      <!-- Field Ends -->
        </div>
      </div>
    </div>

    <!-- Buttons -->
    <div class="row">
      <div class="col-12 py-2">
      <button type="submit" (click)="submitdata()" button-primary-auth class="me-3" style="padding: 15px 45px;"
          [disabled]="!business_details.dirty">
          Save
        </button>
      <button button-login-secondary (click)="initForm()" style="padding: 15px 45px;" *ngIf="business_details.dirty">
          Reset
        </button>
      </div>
    </div>
  </form>
</div>